import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../core/auth.service'; // Asegúrate de importar tu servicio

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule], // ¡Importante importar ReactiveFormsModule!
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  // Inyección de dependencias (Estilo moderno Angular 16+)
  private fb = inject(FormBuilder);
  private authService = inject(AuthService);
  private router = inject(Router);

  loginError: string = '';

  // Definición del formulario
  loginForm = this.fb.group({
    username: ['', [Validators.required]],
    password: ['', [Validators.required]]
  });

  onSubmit() {
    if (this.loginForm.valid) {
      // Limpiamos errores previos
      this.loginError = '';
      
      const credentials = this.loginForm.value;

      this.authService.login(credentials).subscribe({
        next: () => {
          this.router.navigate(['/collections']);
        },
        error: (err) => {
          console.error(err);
          this.loginError = 'Usuario o contraseña incorrectos';
        }
      });
    } else {
      this.loginForm.markAllAsTouched();
    }
  }
}